import { ModalProps } from '../../../../../../models';
import { ModalComponent } from '../../../../../../componets/common';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from 'antd';

export type PleaseNotePopupProps = {
	onGotIt: () => void;
}

export const PleaseNotePopup = (props: ModalProps & PleaseNotePopupProps) => {
	const { isOpen, onClose, onGotIt } = props;
	const { t } = useTranslation()
	return (
		<ModalComponent isOpen={isOpen} onClose={onClose} title={t('pleaseNote')}>
			<div className="modal-content">
				<div className="modal-text">
					<Trans i18nKey="promoNoteText" components={{ space: <br /> }} />
				</div>
				<div className="modal-footer">
					<Button type="primary" style={{ width: '100%' }} onClick={onGotIt}>
						{t('gotItRiskText')}
					</Button>
					<Button style={{ width: '100%' }} onClick={onClose}>
						{t('changeAmount')}
					</Button>
				</div>
			</div>
		</ModalComponent>
	);
}
